module.exports = __webpack_public_path__ + "static/media/21-7.c75b7336.mp3";